import { REPORT_FORMAT_SDA, ReportEntity } from '@app.raytd.com/store';

export default function isSdaFormatReport(report: ReportEntity | null | undefined): boolean {
  return report?.format === REPORT_FORMAT_SDA;
}
